import { ISearchWidget } from 'features/search-widget';

import { abritelSearchWidgetConfig } from './abritel-search-widget.config';
import { bookabachSearchWidgetConfig } from './bookabach-search-widget.config';
import { expediaSearchWidgetConfig } from './expedia-search-widget.config';
import { fewoDirektSearchWidgetConfig } from './fewo-direkt-search-widget.config';
import { hotelsSearchWidgetConfig } from './hotels-search-widget.config';
import { stayzSearchWidgetConfig } from './stayz-search-widget.config';
import { vrboSearchWidgetConfig } from './vrbo-search-widget.config';
import { wotifSearchWidgetConfig } from './wotif-search-widget.config';

const searchWidgetConfig: Record<string, ISearchWidget> = {
  ...abritelSearchWidgetConfig,
  ...bookabachSearchWidgetConfig,
  ...expediaSearchWidgetConfig,
  ...fewoDirektSearchWidgetConfig,
  ...hotelsSearchWidgetConfig,
  ...stayzSearchWidgetConfig,
  ...vrboSearchWidgetConfig,
  ...wotifSearchWidgetConfig,
};

export { searchWidgetConfig };
